import React from 'react'
import {Block} from '../Block'
import {BlockCaption} from '../BlockCaption'
import {BlockOverlay} from '../BlockOverlay'
import {Popover} from 'common/Popover'
import {BlockLoading} from 'common/BlockLoading'
import {Icon} from 'common/LegacyIcon'
import {ClimbAnimation} from 'common/ClimbAnimation'
import {ClimbPicker} from './ClimbPicker'
import _ from 'lodash'
import {findDOMNode} from 'react-dom'
import {shallowCompareObjects} from 'lib/utils'
import {validatedHighlightSlice} from 'lib/reportUtils'

export class ClimbBlock extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      showHelp: false,
      paused: true,
      reselectSegment: false
    }
    this._throttledOnScroll = _.throttle(this.onScroll, 100) // throttle scroll position check to 10Hz
  }

  componentDidMount () {
    window.addEventListener('scroll', this._throttledOnScroll)
    this.onScroll()
  }

  shouldComponentUpdate (nextProps, nextState) {
    return (
      !this.props.blockProps.rides.equals(nextProps.blockProps.rides) ||
      !this.props.block.equals(nextProps.block) ||
      !(this.props.blockProps.isSelected === nextProps.blockProps.isSelected) ||
      shallowCompareObjects(this.state, nextState)
    )
  }

  onScroll = (e) => {
    if (!this._blockRef) { return }
    const rect = findDOMNode(this._blockRef).getBoundingClientRect()

    if (rect.top < 50 || rect.bottom > (window.innerHeight - 100)) {
      !this.state.paused && this.pause()
    } else {
      this.state.paused && this.play()
    }
  }

  toggleHelp = () => {
    const {showHelp} = this.state
    this.setState({showHelp: !showHelp})
  }

  onClimbSelected = ({rideId, highlightSlice}) => {
    if (this.state.reselectSegment) {
      this.setState({reselectSegment: false})
    }
    this.props.blockProps.onChange({rideId, highlightSlice})
  }

  pause = () => {
    this.setState({paused: true})
  }

  play = () => {
    this.setState({paused: false})
  }

  setBlockRef = (ref) => {
    this._blockRef = ref
  }

  reselectClimb = () => this.setState({reselectSegment: true})

  cancelReselect = () => this.setState({reselectSegment: false})

  render () {
    const {rides, metricUnits} = this.props.blockProps
    const {block, blockProps} = this.props
    const {isSelected} = blockProps
    const data = block.getData()
    const rideId = data.get('rideId')
    const ride = rides.get(rideId)
    const highlightSlice = validatedHighlightSlice(data, ride)
    const {paused, reselectSegment, showHelp} = this.state

    if (rideId && !rides.get(rideId)) {
      return <BlockLoading height={200}>Loading...</BlockLoading>
    }

    if (!highlightSlice || !rideId || reselectSegment) {
      return <Block block={block} blockProps={blockProps}>
        <ClimbPicker
          metricUnits={metricUnits}
          cancelable={!!(highlightSlice && rideId)}
          rides={rides}
          onClimbSelected={this.onClimbSelected}
          onCancel={this.cancelReselect} />
      </Block>
    }

    const trackPoints = ride.rawPoints
    return (
      <Block block={block} blockProps={blockProps} ref={this.setBlockRef}>
        {isSelected && <Popover>
          <li onClick={this.reselectClimb}>edit</li>
          <li onClick={this.toggleHelp}><Icon i='help' size={14} /> help</li>
        </Popover>}
        <ClimbAnimation metricUnits={metricUnits} paused={paused} trackPoints={trackPoints} highlightSlice={highlightSlice} />
        <BlockCaption block={this.props.block} blockProps={this.props.blockProps} />
        {showHelp && <Help onClose={this.toggleHelp} />}
      </Block>
    )
  }
}

const Help = ({onClose}) => <BlockOverlay onClose={onClose}>
  <h1>Climb replay</h1>
  <p>Add a Climb block to show readers a replay of an exciting climb segment of your ride.</p>
  <h2>Select segment</h2>
  <p>Generate your climb replay by using the elevation profile to select the segment you would like to re-play. Then click “save.” You can edit or change your climb block by clicking “edit.” This will allow you to re-select the segment to re-play.</p>
</BlockOverlay>
